export default __webpack_public_path__ + "static/media/HBProLogo.58c0a056.svg";